import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { DEFAULT_LOOK_ID } from 'product/constants/constants'
import { useProductInfo } from 'product/services/productInfo/client'

import type { ActiveLineType } from '../types/activePurchases.types'

export const useLineImage = ({ line }: { line: ActiveLineType }) => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const { data } = useProductInfo({
		productId: line.id,
		country: countryISO,
		language: languageISO,
	})

	const colorInfo = data?.colors.find((color) => color.id === line.colorId)
	const defaultLook = colorInfo?.looks[DEFAULT_LOOK_ID]

	return defaultLook?.images['F']?.img ?? defaultLook?.images['B']?.img
}
